import { useContext } from 'react';
import { useParams } from 'react-router';
import { LoginStateContext } from '../Features/Login/Contexts/LoginStateContext/LoginStateContext';

/** @deprecated */
export const useActiveDatabaseName = () => {
  const loginState = useContext(LoginStateContext);
  const { databaseName } = useParams<{ databaseName?: string }>();
  const database = loginState.databases.find(
    database => database.name.toLowerCase() == databaseName?.toLowerCase()
  );
  return database?.name;
};
